

import service from '../../../utils/request'
import allUrl from "../../../utils/setUrl"

/**
 * 上传
 */
export function uploadPictures(data) {
  return service({
    url: allUrl.auth + "/upload/uploadPictures",
    method: "post",
    data,
  });
}

// /**
//  *  获取上传文件真实地址
//  */
// export function getFileUrl(data) {
//   return service({
//     url: allUrl.auth + "/upload/showFile",
//     method: "post",
//     data,
//     type: 'x-www-form-urlencoded'
//   });
// }


/**
 *  获取上传文件真实地址
 */
export function getFileUrl(params) {
  return service({
    url: allUrl.auth + "/upload/getFileUrl",
    method: "get",
    params
  });
}

// 根据类型查询字典详情列表
export function getByType(params){
  return service({
    url:allUrl.auth+'/sys/dict/getByType',
    method:"get",
    params
  })
}

// 根据类型查询字典详情列表
export function getWxConfig(params){
  return service({
    url:allUrl.home+'/weChatPublic/getConfig',
    method:"get",
    params
  })
}



